const config = {
    basename: '',
    defaultPath: '/',
    fontFamily: `'Inter', sans-serif;`,
    borderRadius: 6
};

export default config;
